// No road snapping, interpolation or inferred business events.
export const validPoint = p => Array.isArray(p) && p.length === 2 && p.every(Number.isFinite) && Math.abs(p[0]) <= 180 && Math.abs(p[1]) <= 85.05112878;
export const registration = value => String(value || "").toUpperCase().replace(/[\s-]/g, "");
export function world([lon, lat]) {
  const sin = Math.sin(lat * Math.PI / 180);
  return [(lon + 180) / 360, 0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI)];
}
export function viewport(points) {
  const values = points.filter(validPoint).map(world);
  if (!values.length) return null;
  const xs = values.map(p => p[0]), ys = values.map(p => p[1]);
  const left = Math.min(...xs), right = Math.max(...xs), top = Math.min(...ys), bottom = Math.max(...ys);
  const zoom = Math.max(1, Math.min(16, Math.floor(Math.log2(Math.min(900 / Math.max(right - left, 0.00001), 500 / Math.max(bottom - top, 0.00001)) / 512))));
  const lon = (left + right) / 2 * 360 - 180;
  const lat = Math.atan(Math.sinh(Math.PI * (1 - top - bottom))) * 180 / Math.PI;
  return { lon, lat, zoom };
}
export function project(point, view) {
  const p = world(point), center = world([view.lon, view.lat]), scale = 512 * 2 ** view.zoom;
  return [500 + (p[0] - center[0]) * scale, 300 + (p[1] - center[1]) * scale];
}
export function historyWindow(task, now = Date.now()) {
  const assignment = task.assignment;
  if (!assignment || !assignment.vehicle_ref) return null;
  const to = Math.min(now, Date.parse(task.completed_at) || now, Date.parse(assignment.ended_at) || now);
  const from = Math.max(Date.parse(task.planned_start) || 0, Date.parse(assignment.effective_at) || 0, to - 7 * 86400000, now - 30 * 86400000);
  return from < to ? { from: new Date(from).toISOString(), to: new Date(to).toISOString() } : null;
}
export async function loadObservations(task, getVehicles, getHistory, now = Date.now()) {
  const window = historyWindow(task, now);
  if (!window) return { points: [], note: "Aikaväli tai autokohdistus puuttuu. Vanhan tehtävän historia ei välttämättä ole saatavilla." };
  const vehicles = await getVehicles();
  if (!Array.isArray(vehicles)) throw new Error("Invalid vehicle response");
  const matches = vehicles.filter(v => registration(v.regnumber) === registration(task.assignment.vehicle_ref));
  if (matches.length !== 1 || !Number.isInteger(matches[0].vehicle_id)) return { points: [], note: "Autoa ei voitu yksilöidä paikannusrekisteristä." };
  const id = matches[0].vehicle_id, points = new Map(), cursors = new Set();
  let cursor, coverage;
  for (let page = 0; page < 20; page += 1) {
    const data = await getHistory(id, { ...window, limit: 1000, ...(cursor ? { cursor } : {}) });
    if (data.vehicle_id !== id || !Array.isArray(data.observations) || typeof data.has_more !== "boolean") throw new Error("Invalid history response");
    coverage = data.coverage;
    data.observations.forEach(p => {
      const at = Date.parse(p.observed_at), coord = [p.longitude, p.latitude];
      if (p.vehicle_id !== id || !p.observation_id || !validPoint(coord) || !(at >= Date.parse(window.from) && at < Date.parse(window.to))) throw new Error("Invalid observation");
      points.set(p.observation_id, { ...p, point: coord });
    });
    if (!data.has_more) return { points: [...points.values()].sort((a, b) => Date.parse(a.observed_at) - Date.parse(b.observed_at)), window, coverage };
    if (!data.next_cursor || cursors.has(data.next_cursor)) throw new Error("Invalid cursor");
    cursor = data.next_cursor; cursors.add(cursor);
  }
  // Never silently display the first pages as a complete trace.
  return { points: [...points.values()].sort((a,b) => Date.parse(a.observed_at)-Date.parse(b.observed_at)), window, coverage, note: "Havaintoja on paljon. Näytetään osittainen aineisto (enintään 20 000 havaintoa)." };
}
